import { Navigate, Outlet } from "react-router-dom";
import { useGetUnreadInboxCountQuery } from "../services/apiSlice";

const PrivateRoutes = () => {
  const accessToken = localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");
  const refreshToken =
    localStorage.getItem("refreshToken") || sessionStorage.getItem("refreshToken");
  const isAuthenticated = accessToken || refreshToken;

  useGetUnreadInboxCountQuery({ skip: !isAuthenticated });

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoutes;
